import { render, staticRenderFns } from "./Privew.vue?vue&type=template&id=1c604dc8&scoped=true&"
import script from "./Privew.vue?vue&type=script&lang=js&"
export * from "./Privew.vue?vue&type=script&lang=js&"
import style0 from "./Privew.vue?vue&type=style&index=0&id=1c604dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c604dc8",
  null
  
)

export default component.exports